function normalized(value) {
  const result = typeof value === 'string' ? value.trim() : ''
  return ['null', 'undefined'].includes(result.toLowerCase()) ? '' : result
}

// 线上以域名映射为准；localhost 没有映射时才使用已保存值或显式开发配置。
export function resolveMerchantGuid(apiGuid, storedGuid, developmentGuid) {
  return normalized(apiGuid) || normalized(storedGuid) || normalized(developmentGuid)
}
